export default __webpack_public_path__ + "static/media/person.89f69b5b.svg";